import {
  isValidDate,
  stripTimeFromDate,
} from "@/app/common-utils/travel-date.utils";

import { formatDate } from "./date-picker.utils";
import {
  StartDateValidationTypeAMT,
  StartDateValidationTypeST,
  EndDateValidationTypeST,
} from "../types/travel-dates.type";

// This function validates the end date for Single Trip policies
export const endDateValidationST = ({
  endDate,
  startDate,
  errorMessage,
  maxDateForReturnST,
  setError,
  setTravelDates,
}: EndDateValidationTypeST) => {
  const currentDate = new Date();
  // Validate end date
  if (isValidDate(startDate) && endDate === null) {
    setTravelDates({
      validate: false,
      startDate,
      endDate: null,
    });
    setError(errorMessage?.returnDatePastErrorMessage as string);
    return false;
  }
  if (
    !endDate ||
    !isValidDate(endDate) ||
    endDate.toString() === "Invalid Date"
  ) {
    setError(errorMessage?.returnDatePastErrorMessage as string);
    return false;
  }
  if (endDate > maxDateForReturnST) {
    setError(errorMessage?.returnDateFutureErrorMessage as string);
    return false;
  }
  if (stripTimeFromDate(endDate) < stripTimeFromDate(currentDate)) {
    setError(errorMessage?.returnDatePastErrorMessage as string);
    return false;
  }
  if (stripTimeFromDate(startDate) > stripTimeFromDate(endDate)) {
    setError(errorMessage?.returnDatePastErrorMessage as string);
    return false;
  }
  return true;
};

// This function validates the start date for Single Trip policies
export const startDateValidationST = ({
  startDate,
  errorMessage,
  maxFromDate,
  maxDateForReturnST,
  setError,
}: StartDateValidationTypeST) => {
  const currentDate = new Date();

  // Validate start date
  if (
    !startDate ||
    !isValidDate(startDate) ||
    startDate.toString() === "Invalid Date"
  ) {
    setError(errorMessage?.departureDatePastErrorMessage as string);
    return false;
  }
  if (stripTimeFromDate(startDate) < stripTimeFromDate(currentDate)) {
    setError(errorMessage?.departureDatePastErrorMessage as string);
    return false;
  }
  if (stripTimeFromDate(startDate) > stripTimeFromDate(maxFromDate)) {
    setError(errorMessage?.departureDateFutureErrorMessage as string);
    return false;
  }
  if (stripTimeFromDate(startDate) > stripTimeFromDate(maxDateForReturnST)) {
    setError(errorMessage?.departureDateFutureErrorMessage as string);
    return false;
  }

  return true;
};

// This function validates the start date for Annual Multi-Trip policies
export const startDateValidationAMT = ({
  date,
  errorMessage,
  maxDateforAMT,
  setError,
}: StartDateValidationTypeAMT) => {
  const currentDate = new Date();

  // Check if the date is valid
  if (!isValidDate(date) || formatDate(date) < formatDate(currentDate)) {
    setError(errorMessage.departureDatePastErrorMessage as string);
    return false;
  }

  // Date exceeds max date range not allowed
  if (date > maxDateforAMT) {
    setError(errorMessage.departureDateFutureErrorMessage as string);
    return false;
  }
  return true;
};
